import { Icon } from '@/components/ui/Icon';
import { ICONS } from '@/constants/icons';

export interface FileThumbnailPlaceholderProps {
  /** Fills the parent box — override only if the parent isn't already sized */
  className?: string;
  /** Icon size, tuned to the thumbnail box size at each call site */
  iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * FileThumbnailPlaceholder
 *
 * Neutral placeholder shown instead of an `<img>` for PDF/DOCUMENT media
 * that has no `thumbnailUrl` yet. Prevents feeding a raw `.pdf`/`.docx` URL
 * into an `<img src>` (which renders a broken-image glyph, then a generic
 * placeholder after RetryImage exhausts its retries).
 */
export const FileThumbnailPlaceholder = ({
  className = 'w-full h-full',
  iconSize = 'md',
}: FileThumbnailPlaceholderProps) => (
  <div className={`flex items-center justify-center bg-gray-900 ${className}`}>
    <Icon name={ICONS.FILE} size={iconSize} color="text-gray-300" ariaHidden />
  </div>
);
